<template>
  <div class="header">
    <div class="container">
      <div class="logo-box">
        <img
          src="../assets/img/home-logo.png"
          alt="logo"
          class="logo"
          @click="toHome"
        />
        <!-- <p class="title">FWAlgaeDB</p> -->
      </div>
      <ul class="nav">
        <li v-for="(item, index) in list" :key="index">
          <router-link
            :to="item.path"
            :class="{ active: index == realIndex }"
            class="item"
            >{{ item.name }}</router-link
          >
        </li>
        <div v-if="$store.state.needEnroll">
          <li v-if="$store.state.isEnroll" class="enrolled">
            <router-link to="/personal">
              <img
                class="head"
                src="../assets/img/home-head.png"
                alt="head portrait"
              /><span :class="{ name_active: 5 == realIndex }">{{ $store.state.name }}</span>
            </router-link>
          </li>
          <li v-else>
            <router-link target="_blank" to="/login" class="item"
              >Login</router-link
            >/
            <router-link
              target="_blank"
              to="/register"
              class="item"
              style="margin-left:0"
              >Register</router-link
            >
          </li>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Aheader',
  props: {
    realIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      list: [
        {
          name: 'Home',
          path: '/home'
        },
        {
          name: 'FWAlgae Pool',
          path: '/fwalgaepool'
        },
        {
          name: 'Annotation',
          path: '/annotation'
        },
        {
          name: 'BLAST',
          path: '/blast'
        },
        {
          name: 'About',
          path: '/about'
        }
      ]
    }
  },
  created () {
    this.$store.dispatch('getEnrollState')
  },
  methods: {
    // logo跳回首页
    toHome () {
      this.$router.push('/home')
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2000;
  height: vw(81);
  background-color: #fff;
  line-height: vw(81);
  max-width: vw(1912);
  // width: calc(100% - 17px);
  min-width: vw(1200);

  .container {
    margin: 0 auto;
    width: vw(1200);
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo-box {
      // width: vw(380);
      display: flex;
      align-items: center;

      .logo {
        // margin-right: vw(60);
        // width: vw(186);
        width: vw(193);
        height: vw(43);
        cursor: pointer;
      }

      .title {
        font-size: vw(24);
      }
    }

    .nav {
      display: flex;
      font-size: vw(16);
      font-weight: bold;

      .item {
        margin-left: vw(45);
        cursor: pointer;

        &:hover {
          color: $theme_color;
        }
      }

      .active {
        color: $theme_color;
        position: relative;

        &::after {
          display: block;
          content: '';
          position: absolute;
          bottom: -10px;
          left: 50%;
          transform: translateX(-50%);
          width: vw(20);
          height: 2px;
          background: $theme_color;
          border-radius: 1px;
        }
      }

      .enrolled{
        height: 100%;
        a {
          height: 100%;
          margin-left: vw(45);
          display: flex;
          align-items: center;
          cursor: inherit;

          .head {
            margin-right: vw(10);
            cursor: pointer;
          }
          span {
            cursor: pointer;
          }
          .name_active{
            color: $theme_color;
          }
          &:hover{
            color: $theme_color;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/aheader.vue